<template>
  <div class="profile">
    <div class="container">
      <div class="row mt-4">
        <div class="col-12">
          <h1>Мій профіль</h1>
        </div>
        <div class="col-12 col-md-9">
          <b-card title="Загальні дані" class="mb-4">
            <b-overlay
              :show="isLoading"
              variant="white"
              spinner-variant="primary"
            >
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-input">
                    <label for="">Прізвище</label>
                    <b-form-input v-model="user_data.last_name"> </b-form-input>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-input">
                    <label for="">Імʼя</label>
                    <b-form-input v-model="user_data.first_name">
                    </b-form-input>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-input">
                    <label for="">По-батькові</label>
                    <b-form-input v-model="user_data.middle_name">
                    </b-form-input>
                  </div>
                </div>
              </div>
            </b-overlay>
          </b-card>
          <b-card title="Контакти" class="mb-4">
            <b-overlay
              :show="isLoading"
              variant="white"
              spinner-variant="primary"
            >
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-input">
                    <label for="">Телефон</label>
                    <b-form-input v-model="user_data.phone" disabled />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-input">
                    <label for="">E-mail</label>
                    <b-form-input v-model="user_data.email" disabled />
                  </div>
                </div>
              </div>
            </b-overlay>
          </b-card>
          <b-card title="Резюме" class="mb-4">
            <b-overlay
              :show="isLoading"
              variant="white"
              spinner-variant="primary"
            >
              <p style="color: #666">
                Це чудовий інструмет для того аби більш детально розповісти про
                свій досвід та навчки
              </p>
              <div v-if="user_data.resume_url" class="d-flex">
                <a :href="user_data.resume_url">{{
                  user_data.resume_filename
                }}</a>
                <div class="controls" style="margin-left: auto">
                  <b-button
                    @click="user_data.resume_url = null"
                    size="sm"
                    variant="outline-danger"
                  >
                    Видалити
                  </b-button>
                </div>
              </div>
              <div class="resume-input" v-if="!user_data.resume_url">
                <b-form-file
                  v-model="resume_file"
                  :state="Boolean(resume_file)"
                  accept=".pdf, .doc, .docx, .ppt, .pptx, .pages, .keynote"
                  drop-placeholder="Перетягніть файл сюди..."
                >
                  <template slot="placeholder">
                    <h4 class="mt-2">
                      <b-icon-cloud-upload-fill />
                    </h4>

                    Оберіть файл резюме або перетягніть його сюди
                  </template>
                </b-form-file>
                <div class="d-flex justify-content-end mt-2">
                  <b-button
                    variant="outline-primary"
                    @click="uploadFile"
                    v-if="resume_file"
                    size="sm"
                  >
                    <b-icon-cloud-upload />
                    Завантажити файл
                  </b-button>
                </div>
              </div>
              <input type="file" @change="prepareFile" class="d-none" />
            </b-overlay>
          </b-card>
        </div>
        <div class="col-12 col-md-3">
          <b-button
            @click="saveUser"
            :disabled="isLoading"
            size="lg"
            class="w-100"
            variant="primary"
          >
            Зберегти зміни
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      user_data: {},
      resume_file: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    async getUser() {
      this.isLoading = true;
      let result = await this.$db.getDocument("users", this.user.uid);
      this.user_data = result;
      this.isLoading = false;
    },
    prepareFile(e) {
      let file = e.target.files[0];
      this.resume_file = file;
    },
    async saveUser() {
      this.isLoading = true;
      await this.$db.update("users", this.user.uid, this.user_data);
      this.$toast.success("Зміни збережено");
      this.isLoading = false;
    },
    async uploadFile() {
      this.isLoading = true;
      let file = this.resume_file;
      let path = `resume/${this.user_data.id}/${file.name}`;
      let result = await this.$storage.upload(file, path);
      if (result.url) {
        await this.$db.update("users", this.user.uid, {
          resume_url: result.url,
          resume_filename: file.name,
        });
        window.setTimeout(() => {
          this.getUser();
          this.$toast.success("Резюме збережено");
          this.isLoading = false;
        }, 1000);
      }
    },
  },
  mounted() {
    this.getUser();
  },
};
</script>

<style lang="scss">
.form-input {
  margin-bottom: 20px;
  label {
    font-weight: bold;
    color: var(--primary-color);
    display: block;
    margin-bottom: 6px;
  }
}
.resume-input {
  .b-form-file {
    color: var(--primary-color);
    padding: 16px;
    border: 1px dashed var(--primary-color);
    text-align: center;
  }
  input {
    display: none !important;
  }
}
</style>
